import React from "react";
import SystemLogsFilter from "../../components/SystemLogs-Filter/SystemLogsFilter";
import useSystemLogs from "../../customHooks/SystemLogs/useSystemLogs";
import LogsFilter from "../../components/Logs-Filter/LogsFilter";
import SmallLoader from "../../components/SmallLoader/SmallLoader";
import { LuClipboardCopy } from "react-icons/lu";
import toast, { Toaster } from "react-hot-toast";
import "./SystemLogs.css";
import Pagination from '@mui/material/Pagination';
import { copyTextToClipboard } from "../../utils/helper";

const SystemLogs = () => {
  const talonProps = useSystemLogs();
  const {
    actionOptions,
    searchParams,
    actionType,
    setActionType,
    setSearchParams,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    logs,
    loader,
    currentPage,
    totalCount,
    handlePageChange,
    handlePageSize,
    pageSize,
    onHide,
    show,
    setShow,
    clearEndDate,
    clearStartDate,
    setClearEndDate,
    setClearStartDate,
    showConfirm,
    setShowConfirm,
    limit,
  } = talonProps;
  return (
    <>
      <Toaster
        position="top-center"
        reverseOrder={false}
        gutter={8}
        toastOptions={{
          success: {
            duration: 1500,
            theme: {
              primary: "green",
              secondary: "black",
            },
          },
        }}
      />

      <div className="container">
        <div className="screenRoot">
          <div className="screenTitleSections">
            <div className="screenTitle">Application Logs</div>
            {/* <div className="screenTitleButtons">
              <button
                className="screenTitleButton consistentBtn"
                onClick={() => {
                  setShow(true);
                }}
              >
                Clear Logs
              </button>
            </div> */}
          </div>
        </div>
        <div className="screenBodyRoot">
          <div className="screenTableFeaturesRoot">
            <SystemLogsFilter
              actionOptions={actionOptions}
              searchParams={searchParams}
              actionType={actionType}
              setActionType={setActionType}
              setSearchParams={setSearchParams}
              startDate={startDate}
              setStartDate={setStartDate}
              endDate={endDate}
              setEndDate={setEndDate}
            />
          </div>
          <div className="row d-flex justify-content-between mt-3">
            <div className="col-2 mt-2">
              Showing {logs && logs.length ? logs.length : 0} of {totalCount || 0}
            </div>
            <div className="col-6"></div>
          </div>
          {!loader ? (
            <>
              <div className="screenTableRecordsRoot logScreenRoot">
                {logs.map((log) => {
                  const date = new Date(log.createdAt);
                  const formattedDate = date
                    .toString()
                    .split(" ")
                    .slice(0, 5)
                    .join(" ");

                  return (
                    <div className="logBody mb-3 position-relative">
                      <div className="messageId sys-type">
                        {" "}
                        <span className={log.type}>
                          {log.type.toUpperCase()}
                        </span>
                        {"  "} {formattedDate}
                      </div>
                      <div
                        className={`row px-3 application-logs-container pb-2 grid-container grid-2x2`}
                      >
                        <div className="col-11 messageContent">{log.message}</div>
                        <div className="col-1 ">
                          <span
                            className="copy-btn-sys"
                            onClick={() => {
                              toast.success("Copied");
                              copyTextToClipboard(log.message);
                            }}
                          >
                            <LuClipboardCopy size={20} />
                          </span>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
              {totalCount > pageSize ? (
                <div className="screenTablePaginationRoot">
                 <Pagination
                    // component="div"
                    count={Math.ceil(totalCount/pageSize)}
                    page={currentPage}
                    onChange={handlePageChange}
                    // rowsPerPage={pageSize}
                    // onRowsPerPageChange={handlePageSize}
                  />
                </div>
              ) : null}
            </>
          ) : (
            <div className="screenTableRootLoader">
              <SmallLoader />
            </div>
          )}
          <div></div>
        </div>
      </div>
    </>
  );
};

export default SystemLogs;
